<template>
  <div class="l-container confirm-info ">
    <div class="top-title ">
      <h3 class="font-bold">所属団体様専用ポイント・補助クーポン</h3>
    </div>
    <a-divider/>
    <div class="main-content flex">
      <div class="left-content my-4 ">
        <LeftMenuBar :nav-bars="navBars"/>
      </div>
       <div class="right-content">
        <div class="box-right ">
          <div class="pagination">
            <div class="text-count w-1/5 sm:w-1/2 flex items-center">
              <strong>{{totalCount}}</strong>件中 1～10件表示
            </div>
            <Pagination class="w-3/5 sm:w-full flex justify-center" @onChange="onChange" :page="page" :pageCount="3" :pageSlot="3" :totalRecord="totalCount"/>
            <a-select default-value="0" style="width: 120px" @change="handleChange">
              <a-select-option value="0">
                取得日順
              </a-select-option>
              <a-select-option value="1">
                有効期限が近い順
              </a-select-option>
            </a-select>
          </div>
          <a-divider class="divider"/>
          <div v-for="(item, index) in couponDataList" :key="index">
            <Thumbnail :data="item" @showDetail="showDetail(item)"/> 
            <a-divider class="divider"/>
          </div>
          <div class="pagination">
            <div class="text-count w-1/5 sm:w-1/2 flex items-center">
              <strong>{{totalCount}}</strong>件中 1～10件表示
            </div>
            <Pagination class="w-3/5 sm:w-full flex justify-center" @onChange="onChange" :page="page" :pageCount="5" :pageSlot="5" :totalRecord="totalCount"/>
            <a-select default-value="0" style="width: 120px" @change="handleChange">
              <a-select-option value="0">
                取得日順
              </a-select-option>
              <a-select-option value="1">
                有効期限が近い順
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LeftMenuBar } from '@/components/compound'
import Thumbnail from './Thumbnail/index.vue'
import { GET_COUPON_ITEM_DETAIL } from '@/store/modules/menu/actions.js'
import { GET_COUPON_LIST } from '@/store/modules/bs_app/actions'
import _ from 'lodash'

export default {
  components: {
    LeftMenuBar,
    Thumbnail
  },
  data() {
    return {
      totalCount: '',
      page: '',
      params: {
        isPastCoupon: false,
        page: 1,
        sortBy: 'displayFrom',
        tab: 0
      },
      tab: '',
      couponDataList: [],
      navBars: [
        { path: '/mypage', name: 'マイページトップ' },
        { type: 'divider' },
        { path: '/mypage/benepo-history', name: '総保有ベネポ・ベネポ履歴' },
        { path: '/mypage/benepo-collect', name: '獲得予定のベネポ' },
        { type: 'divider' },
        { path: '/mypage/coupons', name: '専用ポイント・補助クーポン' },
        { type: 'divider' },
        { path: 'bs-myp-02-001', name: 'マイクーポン' },
        { path: 'bs-myp-02-010', name: '過去のクーポン' },
        { type: 'divider' },
        { path: '/mypage/orders', name: 'お申し込み履歴' },
        { path: '', name: '給トク払いご利用履歴', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '/mypage/visits', name: '閲覧履歴' },
        { type: 'divider' },
        { path: '/mypage/favorites', name: 'お気に入りメニュー' },
        { type: 'divider' },
        { path: '/mypage/setting', name: '会員プロフィール', icon: 'icon-bor-copy' },
        { path: '', name: 'メール受信・通知', icon: 'icon-bor-copy' },
        { path: '', name: 'クレジットカード', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: '家族アカウント管理', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: 'ログアウト', icon: 'icon icon-bor-logout' }
      ],
      couponDetail: []

    }
  },
  mounted() {
    this.getCouponList(this.params)
    this.getCouponDetail()
  },
  methods: {
    getCouponList(params) {
      this.$store.dispatch(GET_COUPON_LIST, params).then((data) => {
        if(data !== null) {
          this.totalCount = _.get(data, 'totalCount', '')
          this.couponDataList = _.get(data, 'couponDataList', '')
        }
      })
    },
    onChange(page) {
      this.page = page
      this.params.page = page
      this.getCouponList(this.params)
    },
    handleChange(value) {
      if (value === '1') {
        this.params.sortBy = 'expireTo'
        this.getCouponList(this.params)
        return
      }
      this.params.sortBy = 'displayFrom'
      this.getCouponList(this.params)
    },
   
    getCouponDetail() {
      this.$store.dispatch(GET_COUPON_ITEM_DETAIL).then((data) => { 
        this.couponDetail = data.couponDetail
      }
      )
    },
    async showDetail(item) {
      if (this.tab === 1) {
        this.$router.push(
          `/mypage/coupon/show/member?menuNo=${item.menuNo}&planId=${item.planId}`
        )
      } else {
        this.$router.push(`/coupons/${item.acptNo}`)
      }
    }
    
  },
  computed: {
    couponDescription() {
      if (!this.couponDetail || !this.couponDetail.description) return {}
      return JSON.parse(this.couponDetail.description)
     
    },
    couponCustumItem() {
      if (!this.couponDescription || !this.couponDescription.custumItem) return {}
      return this.couponDescription.custumItem
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>